import { useState, useEffect, useRef } from 'react';

const useElapsedTimeSinceUpdate = (state) => {
  const [lastUpdated, setLastUpdated] = useState(Date.now());
  const elapsedTimeRef = useRef(0);

  useEffect(() => {
    if (state) {
      setLastUpdated(Date.now());
    }
  }, [state]);

  useEffect(() => {
    const interval = setInterval(() => {
      const nextTime = Math.floor((Date.now() - lastUpdated) / 1000);
      elapsedTimeRef.current = nextTime;
    }, 1000);

    return () => clearInterval(interval);
  }, [lastUpdated]);

  return { elapsedTime: elapsedTimeRef.current };
};

export default useElapsedTimeSinceUpdate;
